import * as React from 'react';
import { SVGProps } from 'react';

const IconUserSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 15.095c3.375 0 5-3.495 5-6.595 0-3.1-.5-6.5-5-6.5S9 5.4 9 8.5s1.625 6.595 5 6.595ZM12.778 17C6.056 17 3 20.5 3 26h22c0-7-4.278-9-9.778-9h-2.444Z" />
  </svg>
);
export default IconUserSizeL;
